import $ from 'jquery';
document.jQuery = global.jQuery = $;
document.$ = global.$ = $;
document.jquery = global.jquery = $;

require('admin/accounting/signup')
require("vendor/jquery.maskedinput.min")
require('admin/locations/industries_select')
import {DataBinder} from "utils/data_binder" 
window.DataBinder = DataBinder;
window.numeral = require('vendor/numeral.min')
window.moment = require('moment');
require('bootstrap');

